import { create } from "zustand"

type Store = {
  searchQuery: string
  filter: string
  isCreating: boolean
  setIsCreating: (x: boolean) => void
  setFilter: (filter: string) => void
  setSearchQuery: (searchQuery: string) => void
  showMobileChannel: boolean
  toggleMobileChannel: () => void
  setMutedChannels: (mutedChannels: {}) => void
  mutedChannels: {
    [key: string]: boolean
  }
  setActiveSideBarIndex: (index: number) => void
  activeSideBarIndex: number
}

const filterFacets = {
  all: {
    label: "All",
    filter: {
      type: {
        $in: ["messaging", "creative_networking", "client_job", "creative_job", "client_to_creative_networking"],
      },
    },
  },
  networking: {
    label: "Networking",
    filter: {
      type: {
        $in: ["creative_networking", "client_to_creative_networking"],
      },
    },
  },
  jobs: {
    label: "Jobs",
    filter: {
      type: {
        $in: ["client_job", "creative_job"],
      },
    },
  },
  hidden: {
    label: "Archive",
    filter: {
      hidden: true,
      type: {
        $in: ["creative_networking", "client_to_creative_networking", "client_job", "creative_job"],
      },
    },
  },
}

const filters = Object.entries(filterFacets).map(([key, { label }]) => ({
  label,
  value: key,
}))

const useMessagesStore = create<Store>((set, get) => ({
  searchQuery: "",
  isCreating: false,
  filter: "all",
  mutedChannels: {},
  showMobileChannel: false,
  activeSideBarIndex: 0,
  setActiveSideBarIndex: index => {
    set(() => ({ activeSideBarIndex: index }))
  },
  setIsCreating: isCreating => {
    set(() => ({ isCreating }))
  },
  toggleMobileChannel: () => {
    set(state => ({ showMobileChannel: !state.showMobileChannel }))
  },
  setFilter: (filter: string) => {
    set(() => ({ filter }))
  },
  setSearchQuery: (searchQuery: string) => {
    set(() => ({ searchQuery }))
  },
  setMutedChannels: (newMutedChannel: { [key: string]: boolean }) => {
    set(state => ({
      mutedChannels: {
        ...state.mutedChannels,
        ...newMutedChannel,
      },
    }))
  },
}))

export const useMessages = () => {
  const {
    searchQuery,
    filter,
    setFilter,
    setSearchQuery,
    showMobileChannel,
    setMutedChannels,
    toggleMobileChannel,
    setIsCreating,
    mutedChannels,
    isCreating,
    activeSideBarIndex,
    setActiveSideBarIndex,
  } = useMessagesStore()

  return {
    mutedChannels,
    setMutedChannels,
    searchQuery,
    filter,
    setFilter,
    setSearchQuery,
    filters,
    filterFacets,
    showMobileChannel,
    toggleMobileChannel,
    setIsCreating,
    isCreating,
    activeSideBarIndex,
    setActiveSideBarIndex,
  }
}
